import * as actionTypes from "../actions/sectionsModals/actionTypes";

const sectionsModals = (
  state = {
    isAccountUsersModalOpen: false,
    isSubscriptionsModalOpen: false
  },
  action
) => {
  switch (action.type) {
    case actionTypes.SET_ACCOUNT_USERS_MODAL:
      return Object.assign({}, state, {
        isAccountUsersModalOpen: action.payload.isOpen
      });
    case actionTypes.SET_SUBSCRIPTIONS_MODAL:
      return Object.assign({}, state, {
        isSubscriptionsModalOpen: action.payload.isOpen
      });
    default:
      return state;
  }
};

export default sectionsModals;
